import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import BackArrowButton from "../../../../parts/back-arrow-button";
import SettingsNav from "../../../../parts/settings-nav";
import { canManageOrganizationMembers } from "../../../../utils/organization-permissions-helpers";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";
import { ActiveTabCoachComponent } from "./ActiveTabCoachComponent";
import { InviteNewCoachComponent } from "./InviteNewCoachComponent";
import { PendingTabCoachComponent } from "./PendingTabCoachComponent";
import { getRoleNameById } from "./utils/manage-coaches-utils";

export const ManageCoaches = ({ locals }) => {
  const { t } = useTranslation("dashboard");
  const { query, organizationRoles, activeUser } = locals;
  const { organizationRoleId = null } = activeUser;
  const [tabState, setTabState] = useState("active-tab"); //state to control the active tab
  //to open the invite modal
  const { organizationInviteCoach = false } = query;
  //get the name of the role of the user
  const roleName = getRoleNameById(organizationRoles, organizationRoleId);
  const canManageMembers = canManageOrganizationMembers(roleName);

  /**
   * Change div's content
   * @param {*} tab
   */
  const handleActiveTab = (tab) => {
    setTabState(tab);
  };

  /**
   * Go to invite coach component
   */
  const handleGoToInviteCoach = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { organizationInviteCoach: true },
    });
  };

  //if this query exists, then render the invite coach component
  if (locals.query.organizationInviteCoach) {
    return (
      <InviteNewCoachComponent
        locals={locals}
        roleOrganizationName={roleName}
      />
    );
  } else {
    return (
      <main className="settings">
        <SettingsNav classNames="mobile-hidden" />
        <section className="manage-coaches">
          <div>
            <header>
              <h3 className="force-mobile-hidden">
                {t("manageCoaches.title")}
              </h3>
              <hgroup className="only-show-mobile">
                <SettingsBackHandler title={t("manageCoaches.title")} />
                {canManageMembers && (
                  <a
                    role="button"
                    data-button-type="primary"
                    onClick={handleGoToInviteCoach}
                  >
                    <img src="/img/new-icons/add.svg" alt={t("common:back")} />
                    {t("manageCoaches.inviteNewCoach")}
                  </a>
                )}
              </hgroup>

              <nav role="tablist">
                <a
                  id="active-tab"
                  onClick={() => handleActiveTab("active-tab")}
                  aria-current={tabState === "active-tab" ? true : undefined}
                >
                  {t("manageCoaches.activeCoach")}
                </a>
                <a
                  id="pending-tab"
                  onClick={() => handleActiveTab("pending-tab")}
                  aria-current={tabState === "pending-tab" ? true : undefined}
                >
                  {t("manageCoaches.pendingInvites")}
                </a>
                {canManageMembers && (
                  <a
                    role="button"
                    data-button-type="primary"
                    onClick={handleGoToInviteCoach}
                    className="mobile-hidden"
                  >
                    <img src="/img/new-icons/add.svg" alt={t("common:back")} />
                    {t("manageCoaches.inviteNewCoach")}
                  </a>
                )}
              </nav>
            </header>
            <ul>
              {tabState === "active-tab" ? (
                <ActiveTabCoachComponent locals={locals} roleName={roleName} />
              ) : (
                <PendingTabCoachComponent locals={locals} roleName={roleName} />
              )}
            </ul>
          </div>
          <div>
            <p className="p5">
              {t("manageCoaches.noExtraCharge")}{" "}
              <a
                rel="noopener"
                target="_blank"
                href="https://mystrengthbook.com/pricing"
                className="pricing-organization-anchor"
              >
                {t("manageCoaches.pricing")}
              </a>{" "}
              {t("manageCoaches.onOurWebsite")}
            </p>
          </div>
        </section>
      </main>
    );
  }
};
